import { Dropdown as SlateDropdown } from "../../Dropdown/Dropdown";

export { IOption } from "../../Dropdown/types";
export type { IProps } from "../../Dropdown/types";
export { PortalDropdown } from "../../Dropdown/PortalDropdown";

/**
 * @deprecated since 2025-01-23 in favor of "@faire/web--source/slate/Dropdown#Dropdown"
 *
 * @trackcomponent
 */
export const Dropdown = SlateDropdown;
